import { FC } from 'react';

import ProBlogPost, { ProBlogPostProps } from '../ProBlogPost';

interface Props {
  posts?: Array<ProBlogPostProps>;
}

const ProBlogPostList: FC<Props> = ({ posts = [] }) => (
  <div data-test-id="pro-blog-posts-section">
    {posts.map((post) => (
      <ProBlogPost key={post._id} post={post} />
    ))}
  </div>
);

export type { Props as ProBlogPostListProps };
export default ProBlogPostList;
